import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ⬡ the console greeting. module scope, so it only says hi once.
/* eslint-disable no-console */
console.log(
  '%c⬡ Hi there, nosey.',
  'font-size:22px; font-weight:bold; color:#04919c; font-family:Comfortaa,sans-serif;',
);
console.log(
  "%cI see you looking at my internals, let's take a tour.",
  'font-size:13px; color:#8a8f98;',
);
console.log(
  '%cThe hexagons are load-bearing.\n' +
    '→ Source:   https://github.com/crimsonRIBBON/porfolio-zoe\n' +
    '→ Say hi:   https://www.linkedin.com/in/youfoundzoe/',
  'font-size:12px; color:#8a8f98; line-height:1.7;',
);
/* eslint-enable no-console */

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export {}
reportWebVitals();
